// Client-side scrubbers for session telemetry — the TS twin of
// backend/api/client/controllers/telemetry/shared.js (keep the regexes in
// step). The server re-scrubs everything on ingest; running the same pass
// here is defense in depth AND keeps content off the wire entirely.

const EMAIL_RE = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;
const UUID_RE = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g;
const LONG_DIGITS_RE = /\d{6,}/g;

export function scrubText(value: unknown, max: number): string | null {
  if (typeof value !== 'string') return null;
  const t = value.trim();
  if (!t) return null;
  return t
    .slice(0, max * 2) // scrub before the final cut so redaction can't push content past the cap
    .replace(EMAIL_RE, '[email]')
    .replace(UUID_RE, '[id]')
    .replace(LONG_DIGITS_RE, '[num]')
    .slice(0, max);
}

// Collapse concrete path segments into a template so API timings aggregate:
//   /notes/get-all/3f9e…/42 → /notes/get-all/:id/:id  (query strings dropped)
const TEMPLATE_SEGMENT_RE = /^(\d+|[0-9a-fA-F-]{16,}|[0-9a-zA-Z_-]{20,})$/;

export function templatePath(path: unknown): string | null {
  if (typeof path !== 'string') return null;
  const t = path.trim().slice(0, 600);
  if (!t) return null;
  const [route] = t.split('?');
  return route
    .split('/')
    .map((seg) => (TEMPLATE_SEGMENT_RE.test(seg) ? ':id' : seg))
    .join('/')
    .slice(0, 300);
}

// Session ids must satisfy the server's /^[0-9a-zA-Z-]{16,64}$/ check.
// crypto.randomUUID exists on web and on native via the
// react-native-get-random-values import in index.ts (with the same fallback
// idiom as services/webPush).
export function newSessionId(): string {
  try {
    const c = (globalThis as { crypto?: { randomUUID?: () => string } }).crypto;
    if (c?.randomUUID) return c.randomUUID();
  } catch {
    // fall through to the correlation-id style fallback
  }
  return `s-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}-${Math.random().toString(36).slice(2, 10)}`;
}
